import React from 'react'
import WorkTable from '../components/WorkTable'
import uniqBy from 'lodash.uniqby'
import Footer from '../components/Footer'
import Menu from '../components/Menu'
import getTransitionStyle from '../utils/getTransitionStyle'
import PageAnimations from '../components/PageAnimations'
import { HelmetDatoCms } from 'gatsby-source-datocms'
import IntroInterchangeability from '../components/IntroInterchangeability'

const Interchangeability = ({ data, transition }) => {
  // const isIntroVisible = transition && !transition.previousPathname
  const isIntroVisible = true

  const baseBits = uniqBy(
    data.collections.edges
      .map(x => (
        x.node.combos
          .map(c => c.baseBits)
          .reduce((a, b) => a.concat(b), [])
          .filter(bit => !bit.draft)
      ))
      .reduce((a, b) => a.concat(b), [])
    ,
    'code'
  )

  const optionalBits = uniqBy(
    data.collections.edges
      .map(x => (
        x.node.combos
          .map(c => c.optionalBits)
          .reduce((a, b) => a.concat(b), [])
          .filter(bit => !bit.draft)
      ))
      .reduce((a, b) => a.concat(b), [])
    ,
    'code'
  )

  const status = transition ? transition.status : "entering"
  const timeout = 600

  const menuStyle = getTransitionStyle(status, 200, 2000, 'menuStyle')
  const pageAppear = getTransitionStyle(
    status, timeout, isIntroVisible ? 3000 : 0, 'bgAppear'
  )
  const sectionAppears = getTransitionStyle(
    status, timeout, 1000, 'pageAppearsFromBottom'
  )

  const disappear = getTransitionStyle(
    status, timeout, 3000, 'disappear'
  )
  return (
    <div>
      <div className="intro__overflow--inter" style={disappear}>
        {
          isIntroVisible &&
            <IntroInterchangeability transition={transition} title={data.page.title}/>
        }
      </div>
      <div
        className="interchangeability"
        style={{ backgroundColor: data.page.themeColor.hex }}
      >
        <HelmetDatoCms
          seo={data.page.seo}
          favicon={data.site.favicon}
        />

        <PageAnimations
          status={status}
          timeout={timeout}
          delay={timeout}
          color={data.page.themeColor.hex}
        />

        <Menu
          style={menuStyle}
          hasWhiteLogo={false}
          data={data}
        />

        <div style={sectionAppears}>
            <div className="interchangeability__section">
              <WorkTable
                baseBits={baseBits}
                optionalBits={optionalBits}
                cssModifier="--interchangeability"
                isCollection={false}
                accessoriesModal={data.accessoriesModal.edges.map((x) => x.node)}
              />
            </div>
          </div>
        </div>
        <Footer data={data} />
    </div>
  )
}

export default Interchangeability

export const query = graphql`
  query InterchangeabilityQuery($locale: String!) {

    page: datoCmsInterchangeability(locale: { eq: $locale }) {
      title
      themeColor { hex }
      seo: seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
    }

    site: datoCmsSite {
      favicon: faviconMetaTags {
        ...GatsbyDatoCmsFaviconMetaTags
      }
    }

    collections: allDatoCmsCollection(filter: {interchangeable: {eq: true}, locale: { eq: $locale }}) {
      edges {
        node {
          name
          combos {
            baseBits {
              id
              code
              name
              draft
              canHaveFeet
              stoolOption
              defaultPrice
              colors {
                id
                code
                sku
                name
                price
                swatch {
                  resize(width: 100, imgixParams: { auto: "compress" }) {
                    src
                  }
                }
                bitImage {
                  url
                  normal: resize(width: 600, imgixParams: { auto: "compress", rect: "300,400,840,900" }) {
                    src
                  }
                }
              }
            }
            optionalBits {
              id
              code
              name
              draft
              defaultPrice
              softpadPreview {
                image {
                  resize(width: 600, imgixParams: { auto: "compress", rect: "300,400,840,900" }) {
                    src
                  }
                }
              }
              mysecondskinPreview {
                image {
                  resize(width: 600, imgixParams: { auto: "compress", rect: "300,400,840,900" }) {
                    src
                  }
                }
              }
              colors {
                id
                code
                sku
                price
                name
                swatch {
                  resize(width: 100, imgixParams: { auto: "compress" }) {
                    src
                  }
                }
                bitImage {
                  url
                  normal: resize(width: 600, imgixParams: { auto: "compress", rect: "300,400,840,900" }) {
                    src
                  }
                }
              }
            }
          }
        }
      }
    }

    accessoriesModal: allDatoCmsAccessoriesModal(filter: { locale: { eq: $locale } }) {
      edges {
        node {
          title
          slug
          link
          modalImage {
            resize(width: 600, imgixParams: { auto: "compress" }) {
              src
            }
          }
          designers {
            name
          }
        }
      }
    }

    menuHomepage:           datoCmsHomepage(locale: { eq: $locale })           { menuTitle themeColor { hex } }
    menuInterchangeability: datoCmsInterchangeability(locale: { eq: $locale }) { menuTitle themeColor { hex } slug }
    menuPhilosophy:         datoCmsPhilosophy(locale: { eq: $locale })         { menuTitle themeColor { hex } slug }
    menuNews:               datoCmsNewsHome(locale: { eq: $locale })           { menuTitle themeColor { hex } slug }
    menuAbout:              datoCmsAbout(locale: { eq: $locale })              { menuTitle themeColor { hex } slug }
    menuContact:            datoCmsContact(locale: { eq: $locale })            { menuTitle themeColor { hex } slug }
    menuCatalog:            datoCmsCatalog(locale: { eq: $locale })            { menuTitle themeColor { hex } slug }
    menuDownload:           datoCmsDownloadArea(locale: { eq: $locale })       { menuTitle themeColor { hex } slug }
    menuDesigners:          datoCmsDesignersPage(locale: { eq: $locale })      { menuTitle themeColor { hex } slug }
    menuFooter:             datoCmsFooter                                      { facebook instagram twitter youtube pinterest companyName address: addressNode { markdown: childMarkdownRemark { html } } googleMapsUrl phoneNumber faxNumber vat emailAddress newsletterTitle newsletterDescription}
  }
`



// WEBPACK FOOTER //
// ./src/templates/interchangeability.js